import styled from 'styled-components';

export const ProductCardWrapper = styled.div`
  border: 1px solid #ddd;
  border-radius: 8px;
  /* padding: 16px; */
  text-align: center;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: transform 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  gap: 8px;
  /* max-height: 500px; */
  /* background-size: contain;
  background-position: center;
  background-repeat: no-repeat; */
  font-family: 'FigtreeBold', sans-serif;

  &:hover {
    /* transform: scale(1.05); */
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    cursor: pointer;
  }
`;

export const ProductTitle = styled.h3`
  font-size: 1.4rem;
  font-weight: bold;
  /* margin: 0; */
  color: #333;
`;

export const ProductImage = styled.img`
  /* width: 100px;
  height: 100px; */
  width: 100%;
  height: 100%;
  /* max-height: 300px; */
  object-fit: cover;
  /* border-radius: 4px; */
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;